import React from "react";
import { List, Datagrid, ShowButton, DeleteWithConfirmButton, TextField, DateField } from "react-admin";
import { EmptyList } from "../../../../common/components";
import { thematicCatalogFilter } from "components/features/Partials/Filters";
import { dateOptions } from "utils/options";

const ListTheme = () => {
  return (
    <List
      exporter={false}
      filters={thematicCatalogFilter}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="№"
          source="id"
          sortable={false}
        />
        <TextField
          label="Тема"
          source="name"
          sortable={false}
        />
        <DateField
          label="Дата на публикуване"
          source="started_on"
          locales={"bg"}
          options={dateOptions}
        />
        <ShowButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default ListTheme;
